import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../types';

export const setConfluenceSpace =
	(spaceId: string, spaceName: string): Action<State> =>
	({ getState, setState }) => {
		const state = getState();
		const { pirConfiguration } = state;
		setState({
			...state,
			pirConfiguration: {
				...pirConfiguration,
				selectedConfluenceSpaceId: spaceId,
				selectedConfluenceSpaceName: spaceName,
				selectedConfluenceParentPageId: null,
				selectedConfluenceParentPageName: null,
				isEditEnabled: true,
			},
		});
	};

export const setConfluencePage =
	(parentPageId: string, parentPageName: string): Action<State> =>
	({ getState, setState }) => {
		const state = getState();
		const { pirConfiguration } = state;
		setState({
			...getState(),
			pirConfiguration: {
				...pirConfiguration,
				selectedConfluenceParentPageId: parentPageId,
				selectedConfluenceParentPageName: parentPageName,
				isEditEnabled: true,
			},
		});
	};

export const clearConfluencePage =
	(): Action<State> =>
	({ getState, setState }) => {
		const state = getState();
		const { pirConfiguration } = state;
		setState({
			...getState(),
			pirConfiguration: {
				...pirConfiguration,
				selectedConfluenceParentPageId: null,
				selectedConfluenceParentPageName: null,
			},
		});
	};

export const resetSelectedConfluenceConfig =
	(): Action<State> =>
	({ getState, setState }) => {
		const state = getState();
		const { pirConfiguration } = state;
		const {
			confluenceSpaceId,
			confluenceSpaceName,
			confluenceParentPageId,
			confluenceParentPageName,
		} = pirConfiguration;
		setState({
			...getState(),
			pirConfiguration: {
				...pirConfiguration,
				...{
					selectedConfluenceSpaceId: confluenceSpaceId,
					selectedConfluenceSpaceName: confluenceSpaceName,
					selectedConfluenceParentPageId: confluenceParentPageId,
					selectedConfluenceParentPageName: confluenceParentPageName,
				},
			},
		});
	};
